import RouteWrapper from '../dashboard/routes';
import { StackConfig } from './routeConfig';

function Stack(props: any) {
    const { pathname = '' } = props.location;

    const findPath = (pathname: string) => {
        return pathname.includes('/stack') ? true : false;
    };
    const { path } = props.match;
    return (
        <div>
            <RouteWrapper routes={StackConfig} initPath={`/reset-pin`} matchPath={path} />
        </div>
    );
}

export default Stack;
